import { combineReducers } from 'redux';
import { demographicsListGlobalReducer } from './demographicsListGlobal/demographicsListGlobal.reducer';

export const demographicsReducer = combineReducers({
  listGlobal: demographicsListGlobalReducer,
});
